import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../core/actions/actions';
import './SensorData.css';
import { FormattedMessage, injectIntl } from 'react-intl';
import { formatMessage } from '../../translations/connectedIntlProvider';
import Loader from '../../shared/components/Loader/Loader';
import Grid from '../../shared/components/Grid/Grid';
import IState from '../../core/models/IState';
import { allSensorData } from '../../core/selectors/sensorData.selector';
import Pagination from '../../shared/components/Grid/Pagination';
import IPageInfo from '../../models/IPageInfo';
import sensorIcon from '../../assets/Images/sensor32.png';
import RoutesConstants from '../../shared/components/Routes/routes.constants';
import AddSensorColumnPopupHOC from './hoc/AddSensorColumnPopupHOC';
import AddSensorColumn from './AddSensorColumn';
import modelEnum from '../../constants/model.enum';
import IPageLimit from '../../models/IPageLimit';
import userSettingEnum from '../../constants/userSetting.enum';
import { toast } from 'react-toastify';
import SensorDataDownloadSensor from '../Sensor/SensorDataDownloadSensor';
import DownloadSensorPopupHOC from '../Sensor/hoc/DownloadSensorPopupHOC';
import useWindowDimensions from '../../helpers/windowResize.helper';


const SensorData = (props: any) => {
  /* eslint-disable jsx-a11y/anchor-is-valid */
  const iccid = props.location.state ? props.location.state.iccid : '';
  const model = props.location.state ? props.location.state.model : '';
  // let building = '';
  // let floor = '';
  // let location = '';
  const pager: IPageLimit = useSelector((state: IState) => { return state.pager });
  const language = useSelector((state: IState) => { return state.preferences.language });
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [columnArr, setColumnArr] = useState<any>([]);
  const { columnLists }: any = useSelector((state: IState) => { return state.column });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false
  });

  const [sensorLocation, setSensorLocation] = useState<any>({
    iccid: '',
    model: '',
    building: '',
    floor: '',
    location: '',
    customerId:'',
    room:''
  });


  let paginationData = {
    CurrentPage: 1,
    PageSize: 10,
    OrderBy: 'desc',
    ICCID: '',
    Model: '',
  }
  const getModePrefix = () =>{
    switch(model.toLowerCase()){
        case modelEnum.AQS2.toLowerCase():
            return modelEnum.AQS2.toLowerCase(); 
        case modelEnum.FDS2.toLowerCase():
           return modelEnum.FDS2.toLowerCase();
        case modelEnum.TIS.toLowerCase():
          return modelEnum.TIS.toLowerCase();   
        case modelEnum.PS.toLowerCase():
          return modelEnum.PS.toLowerCase();   
        case modelEnum.AQS3.toLowerCase():
          return modelEnum.AQS3.toLowerCase();   
        default: 
            return '';
    }
  }
  
  let modePrefix = getModePrefix();

  const { height, width } = useWindowDimensions();

  var dataheading = document.getElementById('data-heading');
  
  var windowHeight = width>767? {
    maxHeight: height - 96 - (dataheading == null ? 0 : dataheading.clientHeight)
  }:{
    maxHeight: height - 140 - (dataheading == null ? 0 : dataheading.clientHeight)
  };


  const dispatch = useDispatch();
  const { sensorDataList }: any = useSelector((state: IState) => { return state.sensorData });
  const allSensorsData: any = useSelector(allSensorData);

  const GetSensorData = () => {
    paginationData.CurrentPage = pageInfo.currentPage;
    paginationData.PageSize = pager.pageLimit;
    paginationData.Model = model;
    paginationData.ICCID = iccid;
    if(paginationData.ICCID)
      dispatch(actions.getSensorData(paginationData));
    dispatch(actions.resetGetSensorByIdState());
  }

  const getSensorColumns = () =>{
    switch(model.toLowerCase()){
      case modelEnum.AQS.toLowerCase():
        dispatch(actions.getUserSetting(userSettingEnum.SensorColumnAQS));
        break;
      case modelEnum.FDS.toLowerCase():
        dispatch(actions.getUserSetting(userSettingEnum.SensorColumnFDS));
        break;
      case modelEnum.AQS2.toLowerCase():
        dispatch(actions.getUserSetting(userSettingEnum.SensorColumnAQS2));
        break;  
      case modelEnum.FDS2.toLowerCase():
        dispatch(actions.getUserSetting(userSettingEnum.SensorColumnFDS2));
        break;
      case modelEnum.TIS.toLowerCase():
        dispatch(actions.getUserSetting(userSettingEnum.SensorColumnTIS));
        break;
      case modelEnum.PS.toLowerCase():
        dispatch(actions.getUserSetting(userSettingEnum.SensorColumnPS));
        break;
      default:
        dispatch(actions.getUserSetting(userSettingEnum.SensorColumnAQS3));
    }
  }
  useEffect(() => {
    dispatch(actions.resetGetSensorDataChartState());
    dispatch(actions.resetUserSettingState());
    dispatch(actions.getPageLimit());
    if(props.location.state)
    setSensorLocation({
      ...sensorLocation,
      iccid: props.location.state?.iccid,
      model: props.location.state?.model,
      building: props.location.state?.building,
      location: props.location.state?.location,
      floor: props.location.state?.floor,
      customerId:props.location.state?.customerId,
      room:props.location.state?.room

    });
    getSensorColumns();
    // if (model.toLowerCase() === modelEnum.AQS.toLowerCase()) {
    //   dispatch(actions.getUserSetting(userSettingEnum.SensorColumnAQS));
    // } else {
    //   dispatch(actions.getUserSetting(userSettingEnum.SensorColumnFDS));
    // }
    //GetSensorData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setIsRefreshPage = ()=>{
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  }


  useEffect(() => {
    if (columnLists.success && columnLists.loading === false) {
      if (columnLists.columns.Value) {
        setColumnArr(JSON.parse(columnLists.columns.Value));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnLists.success]);

  // useEffect(() => {
  //   refreshSensorDataClickHandler();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [language])


  const onPageLimitChanged = (evt: any) => {
    let pages: number
    pages = props.data && Math.ceil(props.data.length / evt.target.value)
    setPageInfo({ ...pageInfo, currentPage: 1, totalPages: pages, isPagerChange: false });
    dispatch(actions.updatePagerPageLimit(evt.target.value));
  }

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
    //GetSensorData();
  }

  const downloadSensorClickHandler = () => {
    props.downloadSensorToggleHandler();
  }

  const gotoChartClickHandler = () => {
    dispatch(actions.resetUserSettingState());
    props.history.push({
      pathname: RoutesConstants.SensorDataChart,
      state: {
        iccid: iccid,
        model: model,
        building: props.location.state?.building,
        location: props.location.state?.location,
        floor: props.location.state?.floor,
        customerId:props.location.state?.customerId,
        room:props.location.state?.room
      }
    });
  }

  const refreshSensorDataClickHandler = () => {
    GetSensorData();
  }

  useEffect(() => {
    if (pager.isPageLimitLoaded) {
      GetSensorData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pager.isPageLimitLoaded, pager.pageLimit]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      GetSensorData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (sensorDataList.success && sensorDataList.datas !== undefined) {
      setPageInfo({ ...pageInfo, totalPages: sensorDataList.datas.TotalPages });
      setDisablePagination(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sensorDataList.success])

  useEffect(() => {
    if (sensorDataList.error != null)
      toast.error(formatMessage(sensorDataList.error));
  }, [sensorDataList.error]);

  const openAddColumn = (row: any, isDeleteParam: boolean) => {
    props.addSensorColumToggleHandler();
  }

  const onColumnSave = () => {
    getSensorColumns();
    // if (model.toLowerCase() === modelEnum.AQS.toLowerCase()) {
    //   dispatch(actions.getUserSetting(userSettingEnum.SensorColumnAQS));
    // } else {
    //   dispatch(actions.getUserSetting(userSettingEnum.SensorColumnFDS));
    // }
  }

  const isHidden = (columnName: string) => {
    const isColumnFound = columnArr.includes(columnName);
    return !isColumnFound;
  }

  const sensorDataTable = () =>{
      switch(model.toLowerCase()) {
        case modelEnum.AQS.toLowerCase():
          return allSensorsData.AQSData &&<Grid data={allSensorsData.AQSData} columns={aqscolumns} keyField="ID" />;
        case modelEnum.FDS.toLowerCase():  
          return allSensorsData.FDSData && <Grid data={allSensorsData.FDSData} columns={fdscolumns} keyField="ID" />;
        case modelEnum.AQS2.toLowerCase():  
          return allSensorsData.AQS2Data && <Grid data={allSensorsData.AQS2Data} columns={aqs2columns} keyField="ID" />;    
        case modelEnum.FDS2.toLowerCase():  
          return allSensorsData.FDS2Data && <Grid data={allSensorsData.FDS2Data} columns={fds2columns} keyField="ID" />;
        case modelEnum.TIS.toLowerCase():  
          return allSensorsData.TIoTData && <Grid data={allSensorsData.TIoTData} columns={tiscolumns} keyField="ID" />;
        case modelEnum.PS.toLowerCase():  
          return allSensorsData.PSData && <Grid data={allSensorsData.PSData} columns={pscolumns} keyField="ID" />;
        default:
          return allSensorsData.AQS3Data && <Grid data={allSensorsData.AQS3Data} columns={aqs3columns} keyField="ID" />;
        
       }
    }

  const aqscolumns: any[] = [{
    dataField: 'id',
    text: formatMessage('Label_ID'),
    hidden: true
  },
  {
    dataField: 'ICCID',
    text: formatMessage('iccid'),
    hidden: isHidden('imsi'),
    headerClasses: 'iccid-col'
  },
  {
    dataField: 'CreateTime',
    text: formatMessage('createtimestamp')
  },
  {
    dataField: 'Mode',
    text: formatMessage('mode')
  },
  {
    dataField: 'MeasurementTime',
    text: formatMessage('measurement_date')
  },
  {
    dataField: 'MeasurementInterval',
    text: formatMessage('measurement_interval')
  }, {
    dataField: 'ThunderBoardTemp',
    text: formatMessage('thunderboard_temp'),
    hidden: isHidden('thunderboard_temp')
  },
  {
    dataField: 'ThunderBoardHumidity',
    text: formatMessage('thunderboard_humidity'),
    hidden: isHidden('thunderboard_humidity')
  },
  {
    dataField: 'ThunderBoardIlluminance',
    text: formatMessage('thunderboard_illuminance'),
    hidden: isHidden('thunderboard_illuminance')
  },
  {
    dataField: 'ThunderBoardIlluminanceIndex',
    text: formatMessage('thunderboard_illuminance_index'),
    hidden: isHidden('thunderboard_illuminance_index')
  },
  {
    dataField: 'ThunderBoardAccelarationX',
    text: formatMessage('thunderboard_accelarationx'),
    hidden: isHidden('thunderboard_accelarationx')

  }, {
    dataField: 'ThunderBoardAccelarationY',
    text: formatMessage('thunderboard_accelarationy'),
    hidden: isHidden('thunderboard_accelarationy')

  },
  {
    dataField: 'ThunderBoardAccelarationZ',
    text: formatMessage('thunderboard_accelarationz'),
    hidden: isHidden('thunderboard_accelarationz')
  },
  {
    dataField: 'ThunderBoardBioPressure',
    text: formatMessage('thunderboar_dbio_pressure'),
    hidden: isHidden('thunderboar_dbio_pressure')
  },
  {
    dataField: 'ThunderBoardSoundPressure',
    text: formatMessage('thunderboard_sound_pressure'),
    hidden: isHidden('thunderboard_sound_pressure')
  },
  {
    dataField: 'ThunderBoardCO2',
    text: formatMessage('thunderboard_co2'),
    hidden: isHidden('thunderboard_co2')
  },
  {
    dataField: 'ThunderBoardTVOC',
    text: formatMessage('thunderboard_tvoc'),
    hidden: isHidden('thunderboard_tvoc')
  },
  {
    dataField: 'ThermisterTemp',
    text: formatMessage('thermister_temp'),
    hidden: isHidden('thermister_temp')
  }, {
    dataField: 'ThermisterHumidity',
    text: formatMessage('thermister_humidity'),
    hidden: isHidden('thermister_humidity')
  },
  {
    dataField: 'FoxberryCO2',
    text: formatMessage('foxberry_co2'),
    hidden: isHidden('foxberry_co2')
  },
  {
    dataField: 'FoxberryTemp',
    text: formatMessage('foxberry_temp'),
    hidden: isHidden('foxberry_temp')
  },
  {
    dataField: 'SDC40CO2',
    text: formatMessage('sdc40_co2'),
    hidden: isHidden('sdc40_co2')
  },
  {
    dataField: 'SDC40Temp',
    text: formatMessage('sdc40_temp'),
    hidden: isHidden('sdc40_temp')

  }, {
    dataField: 'SGP40VOCIndex',
    text: formatMessage('sgp40_voc_index'),
    hidden: isHidden('sgp40_voc_index')

  },
  {
    dataField: 'SPS30PM1',
    text: formatMessage('sps30_pm1'),
    hidden: isHidden('sps30_pm1')
  },
  {
    dataField: 'SPS30PM2',
    text: formatMessage('sps30_pm2'),
    hidden: isHidden('sps30_pm2')
  },
  {
    dataField: 'SPS30PM4',
    text: formatMessage('sps30_pm4'),
    hidden: isHidden('sps30_pm4')
  },
  {
    dataField: 'SPS30PM10',
    text: formatMessage('sps30_pm10'),
    hidden: isHidden('sps30_pm10')
  },
  {
    dataField: 'SHT30Temp',
    text: formatMessage('sht30_temp'),
    hidden: isHidden('sht30_temp')
  }, {
    dataField: 'SHT30Humidity',
    text: formatMessage('sht30_humidity'),
    hidden: isHidden('sht30_humidity')
  },
  {
    dataField: 'FSWindSpeed',
    text: formatMessage('fs_wind_speed'),
    hidden: isHidden('fs_wind_speed')
  },
  {
    dataField: 'FSWindSpeedCount',
    text: formatMessage('fs_wind_speed_count'),
    hidden: isHidden('fs_wind_speed_count')
  },
  {
    dataField: 'ThreeSPCO',
    text: formatMessage('three_sp_co'),
    hidden: isHidden('three_sp_co')
  },
  {
    dataField: 'ThreeSPNO2',
    text: formatMessage('three_sp_no2'),
    hidden: isHidden('three_sp_no2')

  }, {
    dataField: 'ThreeSPO3',
    text: formatMessage('three_sp_o3'),
    hidden: isHidden('three_sp_o3')

  },
  {
    dataField: 'ThreeSPSO2',
    text: formatMessage('three_sp_so2'),
    hidden: isHidden('three_sp_so2')
  },
  {
    dataField: 'BCC',
    text: formatMessage('bcc'),
    hidden: isHidden('bcc')
  }];

  const fdscolumns: any[] = [{
    dataField: 'id',
    text: formatMessage('Label_ID'),
    hidden: true
  },
  {
    dataField: 'ICCID',
    text: formatMessage('iccid'),
    hidden: isHidden('imsi'),
    headerClasses: 'iccid-col'
  },
  {
    dataField: 'CreateTime',
    text: formatMessage('createtimestamp')
  },
  {
    dataField: 'Mode',
    text: formatMessage('mode')
  },
  {
    dataField: 'MeasurementTime',
    text: formatMessage('measurement_date')
  }, {
    dataField: 'MeasurementInterval',
    text: formatMessage('measurement_interval')
  },
  {
    dataField: 'ThermisterTemp',
    text: formatMessage('thermister_temp'),
    hidden: isHidden('thermister_temp')
  },
  {
    dataField: 'ThermisterHumidity',
    text: formatMessage('thermister_humidity'),
    hidden: isHidden('thermister_humidity')
  },
  {
    dataField: 'SlightDifferentialPressure',
    text: formatMessage('slightdifferentialpressure'),
    hidden: isHidden('slightdifferentialpressure')
  },
  {
    dataField: 'SPS30_2_PM1_0_Mass',
    text: formatMessage('sps30_2_pm1_0_mass'),
    hidden: isHidden('sps30_2_pm1_0_mass')

  }, {
    dataField: 'SPS30_2_PM2_5_Mass',
    text: formatMessage('sps30_2_pm2_5_mass'),
    hidden: isHidden('sps30_2_pm2_5_mass')

  },
  {
    dataField: 'SPS30_2_PM10_0_Mass',
    text: formatMessage('sps30_2_pm10_0_mass'),
    hidden: isHidden('sps30_2_pm10_0_mass')
  },
  {
    dataField: 'SPS30_2_PM0_5_Number',
    text: formatMessage('sps30_2_pm0_5_number'),
    hidden: isHidden('sps30_2_pm0_5_number')
  },
  {
    dataField: 'SPS30_2_PM1_0_Number',
    text: formatMessage('sps30_2_pm1_0_number'),
    hidden: isHidden('sps30_2_pm1_0_number')
  },
  {
    dataField: 'SPS30_3_PM1_0_Mass',
    text: formatMessage('sps30_3_pm1_0_mass'),
    hidden: isHidden('sps30_3_pm1_0_mass')
  },
  {
    dataField: 'SPS30_3_PM2_5_Mass',
    text: formatMessage('sps30_3_pm2_5_mass'),
    hidden: isHidden('sps30_3_pm2_5_mass')
  },
  {
    dataField: 'SPS30_3_PM10_Mass',
    text: formatMessage('sps30_3_pm10_mass'),
    hidden: isHidden('sps30_3_pm10_mass')
  }, {
    dataField: 'SPS30_3_PM0_5_Number',
    text: formatMessage('sps30_3_pm0_5_number'),
    hidden: isHidden('sps30_3_pm0_5_number')
  },
  {
    dataField: 'SPS30_3_PM1_0_Number',
    text: formatMessage('sps30_3_pm1_0_number'),
    hidden: isHidden('sps30_3_pm1_0_number')
  },
  {
    dataField: 'SHT30Temp',
    text: formatMessage('sht30_temp'),
    hidden: isHidden('sht30_temp')
  },
  {
    dataField: 'SHT30Humidity',
    text: formatMessage('sht30_humidity'),
    hidden: isHidden('sht30_humidity')
  },
  {
    dataField: 'FSWindSpeed',
    text: formatMessage('fs_wind_speed'),
    hidden: isHidden('fs_wind_speed')

  }, {
    dataField: 'FSWindSpeedCount',
    text: formatMessage('fs_wind_speed_count'),
    hidden: isHidden('fs_wind_speed_count')
  },
  {
    dataField: 'BCC',
    text: formatMessage('bcc'),
    hidden: isHidden('bcc')
  }];

  const aqs2columns: any[] = [{
    dataField: 'id',
    text: formatMessage('Label_ID'),
    hidden: true
  },
  {
    dataField: 'ICCID',
    text: formatMessage('iccid'),
    hidden: isHidden('imsi'),
    headerClasses: 'iccid-col'
  },
  {
    dataField: 'CreateTime',
    text: formatMessage('createtimestamp')
  },
  {
    dataField: 'Mode',
    text: formatMessage('mode')
  },
  {
    dataField: 'MeasurementTime',
    text: formatMessage('measurement_date')
  },
  {
    dataField: 'MeasurementInterval',
    text: formatMessage('measurement_interval')
  },
  {
    dataField: 'BatteryVoltage',
    text: formatMessage(modePrefix+'battery_voltage'),
    hidden: isHidden('battery_voltage')
  }, 
  {
    dataField: 'ThunderboardTemperature',
    text: formatMessage(modePrefix+'thunderboard_temp'),
    hidden: isHidden('thunderboard_temp')
  },
  {
    dataField: 'ThunderboardHumidity',
    text: formatMessage(modePrefix+'thunderboard_humidity'),
    hidden: isHidden('thunderboard_humidity')
  },
  {
    dataField: 'ThunderboardMagnetism',
    text: formatMessage(modePrefix+'thunderboard_magnetism'),
    hidden: isHidden('thunderboard_magnetism')
  },
  {
    dataField: 'ThunderboardAccelarationX',
    text: formatMessage(modePrefix+'thunderboard_accelarationx'),
    hidden: isHidden('thunderboard_accelarationx')
  },
  {
    dataField: 'ThunderboardAccelarationY',
    text: formatMessage(modePrefix+'thunderboard_accelarationy'),
    hidden: isHidden('thunderboard_accelarationy')
  },
  {
    dataField: 'ThunderboardAccelarationZ',
    text: formatMessage(modePrefix+'thunderboard_accelarationz'),
    hidden: isHidden('thunderboard_accelarationz')
  },
  {
    dataField: 'ThunderboardBaroPressure',
    text: formatMessage(modePrefix+'thunderboar_baro_pressure'),
    hidden: isHidden('thunderboar_baro_pressure')
  },
  {
    dataField: 'ThunderboardSoundPressure',
    text: formatMessage(modePrefix+'thunderboard_sound_pressure'),
    hidden: isHidden('thunderboard_sound_pressure')
  },
  {
    dataField: 'ThunderboardECO2',
    text: formatMessage(modePrefix+'thunderboard_co2'),
    hidden: isHidden('thunderboard_co2')
  },
  {
    dataField: 'ThunderboardTVOC',
    text: formatMessage(modePrefix+'thunderboard_tvoc'),
    hidden: isHidden('thunderboard_tvoc')
  },
  {
    dataField: 'Thermistor1Temp',
    text: formatMessage(modePrefix+'thermister1_temp'),
    hidden: isHidden('thermister1_temp')
  }, 
  {
    dataField: 'Thermistor2Temp',
    text: formatMessage(modePrefix+'thermister2_temp'),
    hidden: isHidden('thermister2_temp')
  },
  {
    dataField: 'FoxberryCO2',
    text: formatMessage(modePrefix+'foxberry_co2'),
    hidden: isHidden('foxberry_co2')
  },
  {
    dataField: 'FoxberryTemp',
    text: formatMessage(modePrefix+'foxberry_temp'),
    hidden: isHidden('foxberry_temp')
  },
  {
    dataField: 'SDC40CO2',
    text: formatMessage(modePrefix+'sdc40_co2'),
    hidden: isHidden('sdc40_co2')
  },
  {
    dataField: 'SDC40Temp',
    text: formatMessage(modePrefix+'sdc40_temp'),
    hidden: isHidden('sdc40_temp')
  }, {
    dataField: 'FoxberryCO2Avg',
    text: formatMessage(modePrefix+'foxberry_co2_avg'),
    hidden: isHidden('foxberry_co2_avg')
  },
  {
    dataField: 'FoxberryCO2Max',
    text: formatMessage(modePrefix+'foxberry_co2_max'),
    hidden: isHidden('foxberry_co2_max')
  },
  {
    dataField: 'FoxberryCO2Min',
    text: formatMessage(modePrefix+'foxberry_co2_min'),
    hidden: isHidden('foxberry_co2_min')
  },
  {
    dataField: 'FoxberryTempAvg',
    text: formatMessage(modePrefix+'foxberry_temp_avg'),
    hidden: isHidden('foxberry_temp_avg')
  },
  {
    dataField: 'FoxberryTempMax',
    text: formatMessage(modePrefix+'foxberry_temp_max'),
    hidden: isHidden('foxberry_temp_max')
  },
  {
    dataField: 'FoxberryTempMin',
    text: formatMessage(modePrefix+'foxberry_temp_min'),
    hidden: isHidden('foxberry_temp_min')
  }, 
  {
    dataField: 'SDC40CO2Avg',
    text: formatMessage(modePrefix+'sdc40_co2_avg'),
    hidden: isHidden('sdc40_co2_avg')
  },
  {
    dataField: 'SDC40CO2Max',
    text: formatMessage(modePrefix+'sdc40_co2_max'),
    hidden: isHidden('sdc40_co2_max')
  },
  {
    dataField: 'SDC40CO2Min',
    text: formatMessage(modePrefix+'sdc40_co2_min'),
    hidden: isHidden('sdc40_co2_min')
  },
  {
    dataField: 'SDC40TempAvg',
    text: formatMessage(modePrefix+'sdc40_temp_avg'),
    hidden: isHidden('sdc40_temp_avg')
  },
  {
    dataField: 'SDC40TempMax',
    text: formatMessage(modePrefix+'sdc40_temp_max'),
    hidden: isHidden('sdc40_temp_max')

  }, {
    dataField: 'SDC40TempMin',
    text: formatMessage(modePrefix+'sdc40_temp_min'),
    hidden: isHidden('sdc40_temp_min')
  },
  {
    dataField: 'SlightDiffPressure1',
    text: formatMessage(modePrefix+'slight_diff_pressure1'),
    hidden: isHidden('slight_diff_pressure1')
  }, 
  {
    dataField: 'SPS30PM1MassConc',
    text: formatMessage(modePrefix+'sps30_pm1_mass_conc'),
    hidden: isHidden('sps30_pm1_mass_conc')
  },
  {
    dataField: 'SPS30PM2MassConc',
    text: formatMessage(modePrefix+'sps30_pm2_mass_conc'),
    hidden: isHidden('sps30_pm2_mass_conc')
  },
  {
    dataField: 'SPS30PM10MassConc',
    text: formatMessage(modePrefix+'sps30_pm10_mass_conc'),
    hidden: isHidden('sps30_pm10_mass_conc')
  },
  {
    dataField: 'SPS30PM5NoConc',
    text: formatMessage(modePrefix+'sps30_pm5_no_conc'),
    hidden: isHidden('sps30_pm5_no_conc')
  }, {
    dataField: 'SPS30PM1NoConc',
    text: formatMessage(modePrefix+'sps30_pm1_no_conc'),
    hidden: isHidden('sps30_pm1_no_conc')
  },
  {
    dataField: 'ThreeSPNO2',
    text: formatMessage(modePrefix+'three_sp_no2'),
    hidden: isHidden('three_sp_no2')
  },
  {
    dataField: 'ThreeSPO3',
    text: formatMessage(modePrefix+'three_sp_o3'),
    hidden: isHidden('three_sp_o3')
  },
  {
    dataField: 'ThreeSPSO2',
    text: formatMessage(modePrefix+'three_sp_so2'),
    hidden: isHidden('three_sp_so2')
  },
   {
    dataField: 'FECS44Ammonia',
    text: formatMessage(modePrefix+'fecs44_ammonia'),
    hidden: isHidden('fecs44_ammonia')
  },
  {
    dataField: 'TGS5141CO',
    text: formatMessage(modePrefix+'tgs5141_co'),
    hidden: isHidden('tgs5141_co')
  },
  {
    dataField: 'HumanDet1TmeRatio',
    text: formatMessage(modePrefix+'human_det_1_ratio'),
    hidden: isHidden('human_det_1_ratio')
  },
  {
    dataField: 'HumanDet1Number',
    text: formatMessage(modePrefix+'human_det_1_number'),
    hidden: isHidden('human_det_1_number')
  },
  {
    dataField: 'HumanDet2TmeRatio',
    text: formatMessage(modePrefix+'human_det_2_ratio'),
    hidden: isHidden('human_det_2_ratio')
  },
  {
    dataField: 'HumanDet2Number',
    text: formatMessage(modePrefix+'human_det_2_number'),
    hidden: isHidden('human_det_2_number')
  },
  {
    dataField: 'HumanDet3TmeRatio',
    text: formatMessage(modePrefix+'human_det_3_ratio'),
    hidden: isHidden('human_det_3_ratio')

  }, {
    dataField: 'HumanDet3Number',
    text: formatMessage(modePrefix+'human_det_3_number'),
    hidden: isHidden('human_det_3_number')
  },
  {
    dataField: 'HumanDet4TmeRatio',
    text: formatMessage(modePrefix+'human_det_4_ratio'),
    hidden: isHidden('human_det_4_ratio')
  },
  {
    dataField: 'HumanDet4Number',
    text: formatMessage(modePrefix+'human_det_4_number'),
    hidden: isHidden('human_det_4_number')
  },
  {
    dataField: 'WindSpeedAvg',
    text: formatMessage(modePrefix+'wind_speed_avg'),
    hidden: isHidden('wind_speed_avg')
  },
  {
    dataField: 'WindSpeedMax',
    text: formatMessage(modePrefix+'wind_speed_max'),
    hidden: isHidden('wind_speed_max')
  },
  {
    dataField: 'WindSpeedMin',
    text: formatMessage(modePrefix+'wind_speed_min'),
    hidden: isHidden('wind_speed_min')
  },
  {
    dataField: 'WindDirection',
    text: formatMessage(modePrefix+'wind_direction'),
    hidden: isHidden('wind_direction')

  }, {
    dataField: 'BM1422AGMVGeomagnetism',
    text: formatMessage(modePrefix+'bm1422_geomagnetism'),
    hidden: isHidden('bm1422_geomagnetism')
  },
  {
    dataField: 'SHT30Temp',
    text: formatMessage(modePrefix+'sht30_temp'),
    hidden: isHidden('sht30_temp')
  },
  {
    dataField: 'SHT30Humidity',
    text: formatMessage(modePrefix+'sht30_humidity'),
    hidden: isHidden('sht30_humidity')
  },
  {
    dataField: 'BH1721FVCIlluminance',
    text: formatMessage(modePrefix+'bh1721_illuminance'),
    hidden: isHidden('bh1721_illuminance')
  },
  {
    dataField: 'BCC',
    text: formatMessage(modePrefix+'bcc'),
    hidden: isHidden('bcc')
  }];
 
  const fds2columns: any[] = [{
    dataField: 'id',
    text: formatMessage('Label_ID'),
    hidden: true
  },
  {
    dataField: 'ICCID',
    text: formatMessage('iccid'),
    hidden: isHidden('imsi'),
    headerClasses: 'iccid-col'
  },
  {
    dataField: 'CreateTime',
    text: formatMessage('createtimestamp')
  },
  {
    dataField: 'Mode',
    text: formatMessage('mode')
  },
  {
    dataField: 'MeasurementTime',
    text: formatMessage('measurement_date')
  },
  {
    dataField: 'MeasurementInterval',
    text: formatMessage('measurement_interval')
  },
  {
    dataField: 'BatteryVoltage',
    text: formatMessage(modePrefix+'battery_voltage'),
    hidden: isHidden('battery_voltage')
  }, 
  {
    dataField: 'ThunderboardTemperature',
    text: formatMessage(modePrefix+'thunderboard_temp'),
    hidden: isHidden('thunderboard_temp')
  },
  {
    dataField: 'ThunderboardHumidity',
    text: formatMessage(modePrefix+'thunderboard_humidity'),
    hidden: isHidden('thunderboard_humidity')
  },
  {
    dataField: 'ThunderboardMagnetism',
    text: formatMessage(modePrefix+'thunderboard_magnetism'),
    hidden: isHidden('thunderboard_magnetism')
  },
  {
    dataField: 'ThunderboardAccelarationX',
    text: formatMessage(modePrefix+'thunderboard_accelarationx'),
    hidden: isHidden('thunderboard_accelarationx')
  },
  {
    dataField: 'ThunderboardAccelarationY',
    text: formatMessage(modePrefix+'thunderboard_accelarationy'),
    hidden: isHidden('thunderboard_accelarationy')
  },
  {
    dataField: 'ThunderboardAccelarationZ',
    text: formatMessage(modePrefix+'thunderboard_accelarationz'),
    hidden: isHidden('thunderboard_accelarationz')
  },
  {
    dataField: 'ThunderboardBaroPressure',
    text: formatMessage(modePrefix+'thunderboar_baro_pressure'),
    hidden: isHidden('thunderboar_baro_pressure')
  },
  {
    dataField: 'ThunderboardSoundPressure',
    text: formatMessage(modePrefix+'thunderboard_sound_pressure'),
    hidden: isHidden('thunderboard_sound_pressure')
  },
  {
    dataField: 'ThunderboardECO2',
    text: formatMessage(modePrefix+'thunderboard_co2'),
    hidden: isHidden('thunderboard_co2')
  },
  {
    dataField: 'ThunderboardTVOC',
    text: formatMessage(modePrefix+'thunderboard_tvoc'),
    hidden: isHidden('thunderboard_tvoc')
  },
  {
    dataField: 'Thermistor1Temp',
    text: formatMessage(modePrefix+'thermister1_temp'),
    hidden: isHidden('thermister1_temp')
  }, 
  {
    dataField: 'Thermistor2Temp',
    text: formatMessage(modePrefix+'thermister2_temp'),
    hidden: isHidden('thermister2_temp')
  },
  {
    dataField: 'SlightDiffPressure1',
    text: formatMessage(modePrefix+'slight_diff_pressure1'),
    hidden: isHidden('slight_diff_pressure1')
  },
  {
    dataField: 'SPS302PM1MassConc',
    text: formatMessage(modePrefix+'sps30_2_pm1_mass_conc'),
    hidden: isHidden('sps30_2_pm1_mass_conc')
  },
  {
    dataField: 'SPS302PM2MassConc',
    text: formatMessage(modePrefix+'sps30_2_pm2_mass_conc'),
    hidden: isHidden('sps30_2_pm2_mass_conc')
  },
  {
    dataField: 'SPS302PM10MassConc',
    text: formatMessage(modePrefix+'sps30_2_pm10_mass_conc'),
    hidden: isHidden('sps30_2_pm10_mass_conc')
  },
  {
    dataField: 'SPS302PM5NoConc',
    text: formatMessage(modePrefix+'sps30_2_pm5_no_conc'),
    hidden: isHidden('sps30_2_pm5_no_conc')
  }, 
  {
    dataField: 'SPS302PM1NoConc',
    text: formatMessage(modePrefix+'sps30_2_pm1_no_conc'),
    hidden: isHidden('sps30_2_pm1_no_conc')
  },
  {
    dataField: 'SPS303PM1MassConc',
    text: formatMessage(modePrefix+'sps30_3_pm1_mass_conc'),
    hidden: isHidden('sps30_3_pm1_mass_conc')
  },
  {
    dataField: 'SPS303PM2MassConc',
    text: formatMessage(modePrefix+'sps30_3_pm2_mass_conc'),
    hidden: isHidden('sps30_3_pm2_mass_conc')
  },
  {
    dataField: 'SPS303PM10MassConc',
    text: formatMessage(modePrefix+'sps30_3_pm10_mass_conc'),
    hidden: isHidden('sps30_3_pm10_mass_conc')
  },
  {
    dataField: 'SPS303PM5NoConc',
    text: formatMessage(modePrefix+'sps30_3_pm5_no_conc'),
    hidden: isHidden('sps30_3_pm5_no_conc')
  },
  {
    dataField: 'SPS303PM1NoConc',
    text: formatMessage(modePrefix+'sps30_3_pm1_no_conc'),
    hidden: isHidden('sps30_3_pm1_no_conc')
  }, 
  {
    dataField: 'SHT30Temp',
    text: formatMessage(modePrefix+'sht30_temp'),
    hidden: isHidden('sht30_temp')
  },
  {
    dataField: 'SHT30Humidity',
    text: formatMessage(modePrefix+'sht30_humidity'),
    hidden: isHidden('sht30_humidity')
  },
  {
    dataField: 'WindSpeed',
    text: formatMessage(modePrefix+'fs3000_wind_speed'),
    hidden: isHidden('fs3000_wind_speed')
  },
  {
    dataField: 'WindSpeedCount',
    text: formatMessage(modePrefix+'fs3000_wind_speed_count'),
    hidden: isHidden('fs3000_wind_speed_count')
  },
  {
    dataField: 'BCC',
    text: formatMessage(modePrefix+'bcc'),
    hidden: isHidden('bcc')
  }];

  const tiscolumns: any[] = [{
    dataField: 'id',
    text: formatMessage('Label_ID'),
    hidden: true
  },
  {
    dataField: 'ICCID',
    text: formatMessage('iccid'),
    hidden: isHidden('imsi'),
    headerClasses: 'iccid-col'
  },
  {
    dataField: 'CreateTime',
    text: formatMessage('createtimestamp')
  },
  {
    dataField: 'Mode',
    text: formatMessage('mode')
  },
  {
    dataField: 'MeasurementTime',
    text: formatMessage('measurement_date')
  },
  {
    dataField: 'MeasurementInterval',
    text: formatMessage('measurement_interval')
  },
  {
    dataField: 'BatteryVoltage',
    text: formatMessage(modePrefix+'battery_voltage'),
    hidden: isHidden('battery_voltage')
  }, 
  {
    dataField: 'ThunderboardTemperature',
    text: formatMessage(modePrefix+'thunderboard_temp'),
    hidden: isHidden('thunderboard_temp')
  },
  {
    dataField: 'ThunderboardHumidity',
    text: formatMessage(modePrefix+'thunderboard_humidity'),
    hidden: isHidden('thunderboard_humidity')
  },
  {
    dataField: 'ThunderboardMagnetism',
    text: formatMessage(modePrefix+'thunderboard_magnetism'),
    hidden: isHidden('thunderboard_magnetism')
  },
  {
    dataField: 'ThunderboardAccelarationX',
    text: formatMessage(modePrefix+'thunderboard_accelarationx'),
    hidden: isHidden('thunderboard_accelarationx')
  },
  {
    dataField: 'ThunderboardAccelarationY',
    text: formatMessage(modePrefix+'thunderboard_accelarationy'),
    hidden: isHidden('thunderboard_accelarationy')
  },
  {
    dataField: 'ThunderboardAccelarationZ',
    text: formatMessage(modePrefix+'thunderboard_accelarationz'),
    hidden: isHidden('thunderboard_accelarationz')
  },
  {
    dataField: 'ThunderboardBaroPressure',
    text: formatMessage(modePrefix+'thunderboar_baro_pressure'),
    hidden: isHidden('thunderboar_baro_pressure')
  },
  {
    dataField: 'ThunderboardSoundPressure',
    text: formatMessage(modePrefix+'thunderboard_sound_pressure'),
    hidden: isHidden('thunderboard_sound_pressure')
  },
  {
    dataField: 'ThunderboardECO2',
    text: formatMessage(modePrefix+'thunderboard_co2'),
    hidden: isHidden('thunderboard_co2')
  },
  {
    dataField: 'ThunderboardTVOC',
    text: formatMessage(modePrefix+'thunderboard_tvoc'),
    hidden: isHidden('thunderboard_tvoc')
  },
  {
    dataField: 'WeightLoadCell1',
    text: formatMessage(modePrefix+'weight_load_cell_1'),
    hidden: isHidden('weight_load_cell_1')
  }, 
  {
    dataField: 'WeightLoadCell2',
    text: formatMessage(modePrefix+'weight_load_cell_2'),
    hidden: isHidden('weight_load_cell_2')
  },
  {
    dataField: 'SDC40CO2',
    text: formatMessage(modePrefix+'sdc40_co2'),
    hidden: isHidden('sdc40_co2')
  },
  {
    dataField: 'SlightDiffPressure_15_0_Avg',
    text: formatMessage(modePrefix+'slight_diff_press_15_0_avg'),
    hidden: isHidden('slight_diff_press_15_0_avg')
  }, 
  {
    dataField: 'SlightDiffPressure_15_0_Max',
    text: formatMessage(modePrefix+'slight_diff_press_15_0_max'),
    hidden: isHidden('slight_diff_press_15_0_max')
  }, 
  {
    dataField: 'SlightDiffPressure_15_0_Min',
    text: formatMessage(modePrefix+'slight_diff_press_15_0_min'),
    hidden: isHidden('slight_diff_press_15_0_min')
  },
  {
    dataField: 'TempAirVelocity_Avg',
    text: formatMessage(modePrefix+'temp_airvelocity_avg'),
    hidden: isHidden('temp_airvelocity_avg')
  },
  {
    dataField: 'HumidityAirVelocity_Avg',
    text: formatMessage(modePrefix+'hum_airvelocity_avg'),
    hidden: isHidden('hum_airvelocity_avg')
  },
  {
    dataField: 'TempAirVelocity_Max',
    text: formatMessage(modePrefix+'temp_airvelocity_max'),
    hidden: isHidden('temp_airvelocity_max')
  },
  {
    dataField: 'HumidityAirVelocity_Max',
    text: formatMessage(modePrefix+'hum_airvelocity_max'),
    hidden: isHidden('hum_airvelocity_max')
  },
  {
    dataField: 'TempAirVelocity_Min',
    text: formatMessage(modePrefix+'temp_airvelocity_min'),
    hidden: isHidden('temp_airvelocity_min')
  },
  {
    dataField: 'HumidityAirVelocity_Min',
    text: formatMessage(modePrefix+'hum_airvelocity_min'),
    hidden: isHidden('hum_airvelocity_min')
  }, 
  {
    dataField: 'WindSpeed_Avg',
    text: formatMessage(modePrefix+'wind_speed_avg'),
    hidden: isHidden('wind_speed_avg')
  },
  {
    dataField: 'WindSpeedCount_Avg',
    text: formatMessage(modePrefix+'wind_speed_count_avg'),
    hidden: isHidden('wind_speed_count_avg')
  },
  {
    dataField: 'WindSpeed_Max',
    text: formatMessage(modePrefix+'wind_speed_max'),
    hidden: isHidden('wind_speed_max')
  },
  {
    dataField: 'WindSpeedCount_Max',
    text: formatMessage(modePrefix+'wind_speed_count_max'),
    hidden: isHidden('wind_speed_count_max')
  },
  {
    dataField: 'WindSpeed_Min',
    text: formatMessage(modePrefix+'wind_speed_min'),
    hidden: isHidden('wind_speed_min')
  },
  {
    dataField: 'WindSpeedCount_Min',
    text: formatMessage(modePrefix+'wind_speed_count_min'),
    hidden: isHidden('wind_speed_count_min')
  },
  {
    dataField: 'VibBoardAccelarationX_Avg',
    text: formatMessage(modePrefix+'vib_board_acc_x_avg'),
    hidden: isHidden('vib_board_acc_x_avg')
  },
  {
    dataField: 'VibBoardAccelarationY_Avg',
    text: formatMessage(modePrefix+'vib_board_acc_y_avg'),
    hidden: isHidden('vib_board_acc_y_avg')
  },
  {
    dataField: 'VibBoardAccelarationZ_Avg',
    text: formatMessage(modePrefix+'vib_board_acc_z_avg'),
    hidden: isHidden('vib_board_acc_z_avg')
  },
  {
    dataField: 'VibBoardAccelarationX_Max',
    text: formatMessage(modePrefix+'vib_board_acc_x_max'),
    hidden: isHidden('vib_board_acc_x_max')
  },
  {
    dataField: 'VibBoardAccelarationY_Max',
    text: formatMessage(modePrefix+'vib_board_acc_y_max'),
    hidden: isHidden('vib_board_acc_y_max')
  },
  {
    dataField: 'VibBoardAccelarationZ_Max',
    text: formatMessage(modePrefix+'vib_board_acc_z_max'),
    hidden: isHidden('vib_board_acc_z_max')
  },
  {
    dataField: 'VibBoardAccelarationX_Min',
    text: formatMessage(modePrefix+'vib_board_acc_x_min'),
    hidden: isHidden('vib_board_acc_x_min')
  },
  {
    dataField: 'VibBoardAccelarationY_Min',
    text: formatMessage(modePrefix+'vib_board_acc_y_min'),
    hidden: isHidden('vib_board_acc_y_min')
  },
  {
    dataField: 'VibBoardAccelarationZ_Min',
    text: formatMessage(modePrefix+'vib_board_acc_z_min'),
    hidden: isHidden('vib_board_acc_z_min')
  },
  {
    dataField: 'Current_Avg',
    text: formatMessage(modePrefix+'current_avg'),
    hidden: isHidden('current_avg')
  },
  {
    dataField: 'Current_Max',
    text: formatMessage(modePrefix+'current_max'),
    hidden: isHidden('current_max')
  },
  {
    dataField: 'Current_Min',
    text: formatMessage(modePrefix+'current_min'),
    hidden: isHidden('current_min')
  },
  {
    dataField: 'BCC',
    text: formatMessage(modePrefix+'bcc'),
    hidden: isHidden('bcc')
  }];  


  const pscolumns: any[] = [{
    dataField: 'id',
    text: formatMessage('Label_ID'),
    hidden: true
  },
  {
    dataField: 'ICCID',
    text: formatMessage('iccid'),
    hidden: isHidden('imsi'),
    headerClasses: 'iccid-col'
  },
  {
    dataField: 'CreateTime',
    text: formatMessage('createtimestamp')
  },
  {
    dataField: 'Mode',
    text: formatMessage('mode')
  },
  {
    dataField: 'MeasurementTime',
    text: formatMessage('measurement_date')
  }, 
  {
    dataField: 'MeasurementInterval',
    text: formatMessage('measurement_interval')
  },
  {
    dataField: 'Header',
    text: formatMessage(modePrefix+'header'),
    hidden: isHidden('header')
  },
  {
    dataField: 'BatteryVoltage',
    text: formatMessage(modePrefix+'battery_voltage'),
    hidden: isHidden('battery_voltage')
  },
  {
    dataField: 'AveragePower_CurrToM15',
    text: formatMessage(modePrefix+'avgpower_0015'),
    hidden: isHidden('avgpower_0015')
  },
  {
    dataField: 'AveragePower_M15ToM30',
    text: formatMessage(modePrefix+'avgpower_1530'),
    hidden: isHidden('avgpower_1530')
  }, 
  {
    dataField: 'AveragePower_M30ToM45',
    text: formatMessage(modePrefix+'avgpower_3045'),
    hidden: isHidden('avgpower_3045')
  },
  {
    dataField: 'AveragePower_M45ToM60',
    text: formatMessage(modePrefix+'avgpower_4560'),
    hidden: isHidden('avgpower_4560')
  },
  {
    dataField: 'DateNumber',
    text: formatMessage(modePrefix+'dateno'),
    hidden: isHidden('dateno')
  },
  {
    dataField: 'Temperature',
    text: formatMessage(modePrefix+'temperature'),
    hidden: isHidden('temperature')
  },
  {
    dataField: 'Humidity',
    text: formatMessage(modePrefix+'humidity'),
    hidden: isHidden('humidity')
  },
  {
    dataField: 'BCC',
    text: formatMessage(modePrefix+'bcc'),
    hidden: isHidden('bcc')
  }];
  
  const aqs3columns: any[] = [{
    dataField: 'id',
    text: formatMessage('Label_ID'),
    hidden: true
  },
  {
    dataField: 'ICCID',
    text: formatMessage('iccid'),
    hidden: isHidden('imsi'),
    headerClasses: 'iccid-col'
  },
  {
    dataField: 'CreateTime',
    text: formatMessage('createtimestamp')
  },
  {
    dataField: 'Mode',
    text: formatMessage('mode')
  },
  {
    dataField: 'MeasurementTime',
    text: formatMessage('measurement_date')
  }, 
  {
    dataField: 'MeasurementInterval',
    text: formatMessage('measurement_interval')
  },
  {
    dataField: 'BatteryVoltage',
    text: formatMessage(modePrefix+'battery_voltage'),
    hidden: isHidden('battery_voltage')
  },
  {
    dataField: 'DataCount',
    text: formatMessage(modePrefix+'data_count'),
    hidden: isHidden('data_count')
  },
  {
    dataField: 'SerialNumber',
    text: formatMessage(modePrefix+'serial_number'),
    hidden: isHidden('serial_number')
  },
  {
    dataField: 'TemperatureSHT30',
    text: formatMessage(modePrefix+'temp_sht30'),
    hidden: isHidden('temp_sht30')
  }, 
  {
    dataField: 'HumiditySHT30',
    text: formatMessage(modePrefix+'humidity_sht30'),
    hidden: isHidden('humidity_sht30')
  },
  {
    dataField: 'CO2Sunrise',
    text: formatMessage(modePrefix+'co2_sunrise'),
    hidden: isHidden('co2_sunrise')
  },
  {
    dataField: 'COFigaro',
    text: formatMessage(modePrefix+'co_figaro'),
    hidden: isHidden('co_figaro')
  },
  {
    dataField: 'AirFlowKOA',
    text: formatMessage(modePrefix+'airflow_koa'),
    hidden: isHidden('airflow_koa')
  },
  {
    dataField: 'PM01SPS30M3',
    text: formatMessage(modePrefix+'pm_01_sps30_m3'),
    hidden: isHidden('pm_01_sps30_m3')
  },
  {
    dataField: 'PM25SPS30M3',
    text: formatMessage(modePrefix+'pm_25_sps30_m3'),
    hidden: isHidden('pm_25_sps30_m3')
  },
  {
    dataField: 'PM04SPS30M3',
    text: formatMessage(modePrefix+'pm_04_sps30_m3'),
    hidden: isHidden('pm_04_sps30_m3')
  },
  {
    dataField: 'PM10SPS30M3',
    text: formatMessage(modePrefix+'pm_10_sps30_m3'),
    hidden: isHidden('pm_10_sps30_m3')
  }, 
  {
    dataField: 'PM05SPS30CM3',
    text: formatMessage(modePrefix+'pm_05_sps30_cm3'),
    hidden: isHidden('pm_05_sps30_cm3')
  },
  {
    dataField: 'PM01SPS30CM3',
    text: formatMessage(modePrefix+'pm_01_sps30_cm3'),
    hidden: isHidden('pm_01_sps30_cm3')
  },
  {
    dataField: 'PM25SPS30CM3',
    text: formatMessage(modePrefix+'pm_25_sps30_cm3'),
    hidden: isHidden('pm_25_sps30_cm3')
  },
  {
    dataField: 'PM04SPS30CM3',
    text: formatMessage(modePrefix+'pm_04_sps30_cm3'),
    hidden: isHidden('pm_04_sps30_cm3')
  },
  {
    dataField: 'PM10SPS30CM3',
    text: formatMessage(modePrefix+'pm_10_sps30_cm3'),
    hidden: isHidden('pm_10_sps30_cm3')
  },
  {
    dataField: 'VOC',
    text: formatMessage(modePrefix+'voc'),
    hidden: isHidden('voc')
  },
  {
    dataField: 'TVOCIAQ',
    text: formatMessage(modePrefix+'tvoc_iaq'),
    hidden: isHidden('tvoc_iaq')
  },
  {
    dataField: 'TVOCOAQ',
    text: formatMessage(modePrefix+'tvoc_oaq'),
    hidden: isHidden('tvoc_oaq')
  },
  {
    dataField: 'AirPressure',
    text: formatMessage(modePrefix+'air_pressure'),
    hidden: isHidden('air_pressure')
  }, 
  {
    dataField: 'TemperatureSHT30Min',
    text: formatMessage(modePrefix+'temp_sht30_min'),
    hidden: isHidden('temp_sht30_min')
  },
  {
    dataField: 'TemperatureSHT30Max',
    text: formatMessage(modePrefix+'temp_sht30_max'),
    hidden: isHidden('temp_sht30_max')
  },
  {
    dataField: 'TemperatureSHT30Avg',
    text: formatMessage(modePrefix+'temp_sht30_avg'),
    hidden: isHidden('temp_sht30_avg')
  },
  {
    dataField: 'HumiditySHT30Min',
    text: formatMessage(modePrefix+'humidity_sht30_min'),
    hidden: isHidden('humidity_sht30_min')
  },
  {
    dataField: 'HumiditySHT30Max',
    text: formatMessage(modePrefix+'humidity_sht30_max'),
    hidden: isHidden('humidity_sht30_max')
  },
  {
    dataField: 'HumiditySHT30Avg',
    text: formatMessage(modePrefix+'humidity_sht30_avg'),
    hidden: isHidden('humidity_sht30_avg')
  },
  {
    dataField: 'CO2SunriseMin',
    text: formatMessage(modePrefix+'co2_sunrise_min'),
    hidden: isHidden('co2_sunrise_min')
  },
  {
    dataField: 'CO2SunriseMax',
    text: formatMessage(modePrefix+'co2_sunrise_max'),
    hidden: isHidden('co2_sunrise_max')
  },
  {
    dataField: 'CO2SunriseAvg',
    text: formatMessage(modePrefix+'co2_sunrise_avg'),
    hidden: isHidden('co2_sunrise_avg')
  },
  {
    dataField: 'COFigaroMin',
    text: formatMessage(modePrefix+'co_figaro_min'),
    hidden: isHidden('co_figaro_min')
  },
  {
    dataField: 'COFigaroMax',
    text: formatMessage(modePrefix+'co_figaro_max'),
    hidden: isHidden('co_figaro_max')
  },
  {
    dataField: 'COFigaroAvg',
    text: formatMessage(modePrefix+'co_figaro_avg'),
    hidden: isHidden('co_figaro_avg')
  },
  {
    dataField: 'AirFlowKOAMin',
    text: formatMessage(modePrefix+'airflow_koa_min'),
    hidden: isHidden('airflow_koa_min')
  },
  {
    dataField: 'AirFlowKOAMax',
    text: formatMessage(modePrefix+'airflow_koa_max'),
    hidden: isHidden('airflow_koa_max')
  },
  {
    dataField: 'AirFlowKOAAvg',
    text: formatMessage(modePrefix+'airflow_koa_avg'),
    hidden: isHidden('airflow_koa_avg')
  },
  {
    dataField: 'PM01SPS30M3Min',
    text: formatMessage(modePrefix+'pm_01_sps30_m3_min'),
    hidden: isHidden('pm_01_sps30_m3_min')
  },
  {
    dataField: 'PM01SPS30M3Max',
    text: formatMessage(modePrefix+'pm_01_sps30_m3_max'),
    hidden: isHidden('pm_01_sps30_m3_max')
  },
  {
    dataField: 'PM01SPS30M3Avg',
    text: formatMessage(modePrefix+'pm_01_sps30_m3_avg'),
    hidden: isHidden('pm_01_sps30_m3_avg')
  },
  {
    dataField: 'PM25SPS30M3Min',
    text: formatMessage(modePrefix+'pm_25_sps30_m3_min'),
    hidden: isHidden('pm_25_sps30_m3_min')
  },
  {
    dataField: 'PM25SPS30M3Max',
    text: formatMessage(modePrefix+'pm_25_sps30_m3_max'),
    hidden: isHidden('pm_25_sps30_m3_max')
  },
  {
    dataField: 'PM25SPS30M3Avg',
    text: formatMessage(modePrefix+'pm_25_sps30_m3_avg'),
    hidden: isHidden('pm_25_sps30_m3_avg')
  },
  {
    dataField: 'PM04SPS30M3Min',
    text: formatMessage(modePrefix+'pm_04_sps30_m3_min'),
    hidden: isHidden('pm_04_sps30_m3_min')
  },
  {
    dataField: 'PM04SPS30M3Max',
    text: formatMessage(modePrefix+'pm_04_sps30_m3_max'),
    hidden: isHidden('pm_04_sps30_m3_max')
  },
  {
    dataField: 'PM04SPS30M3Avg',
    text: formatMessage(modePrefix+'pm_04_sps30_m3_avg'),
    hidden: isHidden('pm_04_sps30_m3_avg')
  },
  {
    dataField: 'PM10SPS30M3Min',
    text: formatMessage(modePrefix+'pm_10_sps30_m3_min'),
    hidden: isHidden('pm_10_sps30_m3_min')
  }, 
  {
    dataField: 'PM10SPS30M3Max',
    text: formatMessage(modePrefix+'pm_10_sps30_m3_max'),
    hidden: isHidden('pm_10_sps30_m3_max')
  },
  {
    dataField: 'PM10SPS30M3Avg',
    text: formatMessage(modePrefix+'pm_10_sps30_m3_avg'),
    hidden: isHidden('pm_10_sps30_m3_avg')
  },
  {
    dataField: 'VOCMin',
    text: formatMessage(modePrefix+'voc_min'),
    hidden: isHidden('voc_min')
  },
  {
    dataField: 'VOCMax',
    text: formatMessage(modePrefix+'voc_max'),
    hidden: isHidden('voc_max')
  },
  {
    dataField: 'VOCAvg',
    text: formatMessage(modePrefix+'voc_avg'),
    hidden: isHidden('voc_avg')
  },
  {
    dataField: 'TVOCIAQMin',
    text: formatMessage(modePrefix+'tvoc_iaq_min'),
    hidden: isHidden('tvoc_iaq_min')
  },
  {
    dataField: 'TVOCIAQMax',
    text: formatMessage(modePrefix+'tvoc_iaq_max'),
    hidden: isHidden('tvoc_iaq_max')
  },
  {
    dataField: 'TVOCIAQAvg',
    text: formatMessage(modePrefix+'tvoc_iaq_avg'),
    hidden: isHidden('tvoc_iaq_avg')
  },
  {
    dataField: 'TVOCOAQMin',
    text: formatMessage(modePrefix+'tvoc_oaq_min'),
    hidden: isHidden('tvoc_oaq_min')
  },
  {
    dataField: 'TVOCOAQMax',
    text: formatMessage(modePrefix+'tvoc_oaq_max'),
    hidden: isHidden('tvoc_oaq_max')
  },
  {
    dataField: 'TVOCOAQAvg',
    text: formatMessage(modePrefix+'tvoc_oaq_avg'),
    hidden: isHidden('tvoc_oaq_avg')
  }
];


  return (
    <React.Fragment>
      {
        props.showAddSensorColumnPopup &&
        <AddSensorColumn
          from='SensorData'
          model={model}
          columnSave={onColumnSave}
          modalClosed={props.addSensorColumToggleHandler} />
      }

      {
        props.showDownloadSensorPopup &&
        <SensorDataDownloadSensor
          model={model}
          id={iccid}
          modalClosed={props.downloadSensorToggleHandler}
        />
      }

      <div className="icon-nav navbar-fixed-top device-nav-bar">
        <div className="container-fluid">
          <div className="filter-left-area">
            <ul>
              <li><h1><img src={sensorIcon} alt=""></img> <FormattedMessage id='Sensor_Data_Title' /></h1></li>
            </ul>
          </div>

          <div className="add-list float-right">
            <ul>

              <li title={formatMessage('Add_Sesnor_Columns')}>
                <a data-toggle="modal" onClick={() => openAddColumn({ id: -1, iccid: '' }, false)} data-target="#addSensor">
                  <i className="material-icons">view_day</i>
                </a>
              </li>
              <li title={formatMessage('Download')}>
                <a data-toggle="modal" onClick={() => downloadSensorClickHandler()}>
                  <svg width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                  </svg>
                </a>
              </li>

              <li title={formatMessage('Chart')}>
                <a data-toggle="modal" onClick={() => gotoChartClickHandler()}>
                  <svg width="16" height="16" fill="currentColor" className="bi bi-graph-up" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M0 0h1v15h15v1H0V0zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5z" />
                  </svg>
                </a>
              </li>
              <li title={formatMessage('Refresh')}>
                <a data-toggle="modal" onClick={() => refreshSensorDataClickHandler()}>
                  <svg width="16" height="16" fill="currentColor" className="bi bi-arrow-repeat" viewBox="0 0 16 16">
                    <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                    <path fillRule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                  </svg>
                </a>
              </li>
              <li className="page-number">
                <Pagination isRefreshPage={false} totalPages={pageInfo.totalPages} pageLimit={pager.pageLimit} onPageChanged={onPageChanged} disablePagination={disablePagination} setIsRefreshPage={setIsRefreshPage} />
              </li>
              <li className="page-count-no">
                <select className='pageLimit' onChange={onPageLimitChanged} value={pager.pageLimit}>
                  {pager.pageLimitOptions.map((op: any) => <option key={op} value={op}>{op}</option>)}
                </select>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="col-12 mb-3 data-heading" id="data-heading">
        <div className="d-md-flex">

          {/* <div className="mr-3 iccid-col">
              <h4>{formatMessage('Sensor_Table_Col_ICCID')}</h4>
              <h5>{sensorLocation.iccid}</h5>
          </div> */}
          
          <div className="mr-md-3 w-100">
              <h4>{formatMessage("Sensor_Table_Col_CustomerId")}</h4>
              <h5>{sensorLocation.customerId}</h5>
          </div>
          <div className="mr-md-3 w-100">
              <h4>{formatMessage("Sensor_type")}</h4>
              <h5>{sensorLocation.model}</h5>
          </div>
          <div className="mx-md-3 w-100">
              <h4>{formatMessage("Sensor_Table_Col_Building")}</h4>
              <h5>{sensorLocation.building}</h5>
          </div>
          <div className="mx-md-3 w-100">
              <h4>{formatMessage("Sensor_Table_Col_Floor")}</h4>
              <h5>{sensorLocation.floor}</h5>
          </div>
          <div className="mx-md-3 w-100">
              <h4>{formatMessage("Sensor_Table_Col_Room")}</h4>
              <h5>{sensorLocation.room}</h5>
          </div>
          <div className="ml-md-3 w-100">
              <h4>{formatMessage("Sensor_Table_Col_Location")}</h4>
              <h5>{sensorLocation.location}</h5>
          </div>
        </div>
      </div>


      <div className="device-detail">
        <div className="table-responsive" style={windowHeight}>
          {
          sensorDataList.loading && columnLists.loading ? <Loader /> : 
          sensorDataTable()
          // model.toLowerCase() === modelEnum.AQS.toLowerCase() ? 
          // allSensorsData.AQSData && <Grid data={allSensorsData.AQSData} columns={aqscolumns} keyField="ID" /> : 
          // allSensorsData.FDSData && <Grid data={allSensorsData.FDSData} columns={fdscolumns} keyField="ID" />
        }
        </div>
      </div>

    </React.Fragment>
  )
};

export default injectIntl(AddSensorColumnPopupHOC(DownloadSensorPopupHOC(SensorData)));
